// Google Tag Manager is production-only. Local development must never
// contact Google, even when the developer's .env still carries a container
// id and an old consent choice says "accepted".
const LOOPBACK_HOSTS = new Set([
  'localhost',
  '127.0.0.1',
  '0.0.0.0',
  '::1',
  '[::1]',
]);

const PRIVATE_IPV4 = /^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|169\.254\.)/;

export const isLocalHostname = (hostname = '') => {
  const host = String(hostname).trim().toLowerCase().replace(/^\[|\]$/g, '');
  if (!host) return false;
  return LOOPBACK_HOSTS.has(host)
    || LOOPBACK_HOSTS.has(`[${host}]`)
    || host.endsWith('.local')
    || PRIVATE_IPV4.test(host);
};

export const resolveTrackingEnabled = ({
  nodeEnv,
  hostname,
  gtmId,
  enabledFlag,
} = {}) => {
  if (nodeEnv === 'development') return false;
  if (String(enabledFlag || '').trim().toLowerCase() === 'false') return false;
  if (!gtmId) return false;
  return !isLocalHostname(hostname);
};

export const trackingEnabled = resolveTrackingEnabled({
  nodeEnv: process.env.NODE_ENV,
  hostname: typeof window !== 'undefined' ? window.location.hostname : '',
  gtmId: process.env.REACT_APP_GTM_ID,
  enabledFlag: process.env.REACT_APP_TRACKING_ENABLED,
});
